var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-navigation-new"},[_c('NcButton',{attrs:{"id":_vm.buttonId,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._t("icon")]},proxy:true}],null,true)},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }